import { render, staticRenderFns } from "./edizioneFormazione.html?vue&type=template&id=755d517d&external"
import script from "./EdizioneFormazione.vue?vue&type=script&lang=js"
export * from "./EdizioneFormazione.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports